import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';

import CaregiverSettingsData from './CaregiverSettingsData';
import CaregiverSettingsDrawer from './CaregiverSettingsDrawer';

const CaregiverSettings = (props) => {
  const {showSettings, openDrawerView, setOpenDrawerView} = props;

  return (
    <>
      {
        !showSettings &&
        <Box sx={{width: '23vw', maxWidth: '296px', position: 'sticky', top: 16}}>
          <CaregiverSettingsData
            {...props}
          />
        </Box>
      }
      {
        openDrawerView &&
        <CaregiverSettingsDrawer
          settingsDrawerOpen={openDrawerView}
          setSettingsDrawerOpen={setOpenDrawerView}
        >

          <CaregiverSettingsData
            {...props}
          />
        </CaregiverSettingsDrawer>
      }
    </>
  );
};

CaregiverSettings.propTypes = {
  showSettings: PropTypes.bool.isRequired,
  openDrawerView: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(CaregiverSettings));
